'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var utils = require('@chakra-ui/utils');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/**
 * ColumnCardContent
 *
 * Wraps the ColumnCard's content (header, body, footer) into one column
 */
var ColumnCardContent = react.forwardRef(function (props, ref) {
  var styles = react.useStyles();
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.div, _extends__default["default"]({
    ref: ref,
    __css: styles.content
  }, props, {
    className: utils.cx('chakra-column-card__content', props.className)
  }));
});
ColumnCardContent.displayName = 'ColumnCardContent';
exports.ColumnCardContent = ColumnCardContent;